"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveManager = void 0;
var job_1 = require("./job/job");
var job_observable_1 = require("./job/job-observable");
/**
 * Archive Manager. Lets create and extract archives
 * @doc ArchiveManager
 */
var ArchiveManager = /** @class */ (function () {
    function ArchiveManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        this.baseUrl = 'https://' + configuration.domain;
    }
    /**
     * @param {CreateArchiveRequest?} createArchiveRequest
     * @returns {Promise<Job<CreateArchiveSpecification>>}
     */
    ArchiveManager.prototype.createArchive = function (createArchiveRequest) {
        return this.httpClient
            .post(this.baseUrl + "/_api/archive/create", createArchiveRequest)
            .then(function (response) {
            return new job_1.Job(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     *
     * @param {IExtractArchiveRequest} createArchiveRequest
     * @returns {Observable<CreateArchiveSpecification>}
     *
     * @example
     * archiveManager
     *   .createArchiveObservable({
     *     source: {
     *       fileId: '#file-id
     *     },
     *     destination: {
     *       path: '/demo/path',
     *       acl: 'public'
     *     }
     *   })
     *   .subscribe(job => {
     *     console.log(job.status);
     *   });
     */
    ArchiveManager.prototype.createArchiveObservable = function (createArchiveRequest) {
        var _this = this;
        return job_observable_1.observeJobCreator(this.configuration, this.httpClient)(function () { return _this.createArchive(createArchiveRequest); });
    };
    ArchiveManager.prototype.doExtractArchive = function (extractArchiveRequest) {
        return this.httpClient.post(this.baseUrl + "/_api/archive/extract", extractArchiveRequest);
    };
    ArchiveManager.prototype.extractArchiveObservable = function (extractArchiveRequest) {
        var _this = this;
        return job_observable_1.observeJobCreator(this.configuration, this.httpClient)(function () { return _this.extractArchive(extractArchiveRequest); });
    };
    /**
     * @param {ExtractArchiveRequest?} extractArchiveRequest
     * @returns {Promise<Job<ExtractArchiveSpecification>>}
     */
    ArchiveManager.prototype.extractArchive = function (extractArchiveRequest) {
        return this.doExtractArchive(extractArchiveRequest).then(function (response) {
            return new job_1.Job(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    return ArchiveManager;
}());
exports.ArchiveManager = ArchiveManager;
//# sourceMappingURL=archive-manager.js.map